module.exports = __webpack_public_path__ + "img/Spread_1.4003fea7.jpg";